import { t } from 'i18next';
import types from '../actionTypes';

const INITIAL_STATE = {
  httpservice: [],
  menuopen: true,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.API_ERROR:
      return {
        ...state,
        httpserviceError: action.payload,
      };
    case types.API_SUCCESS:
        return {
          ...state,
          httpserviceSuccess: action.payload,
        };
    case types.MENU_OPEN:
      return {
        ...state,
        menuopen: action.payload
      }
      
    default:
      return state;
  }
};
